import { render, staticRenderFns } from "./tabs.vue?vue&type=template&id=8222e78e&"
import script from "./tabs.vue?vue&type=script&lang=js&"
export * from "./tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tabs.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/base/tabs/tabs.vue
// module id = 155
// module chunks = 0